<template>
  <div v-loading="loading"></div>
</template>

<script>
import { getWxApiToken, checkQrCodeGuid } from '@/request/api.js'
import { Notify } from 'vant'
import { Base64 } from 'js-base64'
export default {
  data () {
    return {
      module: this.$route.query.module || '240',
      restype: this.$route.query.restype || '',
      guid: this.$route.query.guid || '',
      autoid: this.$route.query.autoid || '',
      loading: true
    }
  },
  created () {
    // 获取路由参数
    // let params = this.$route.query.param
    // if (params)    {
    //   params = JSON.parse(Base64.decode(params))
    // }
    this.module = this.$route.query.module
    this.restype = this.$route.query.restype
    this.guid = this.$route.query.guid
    this.autoid = this.$route.query.autoid

    getWxApiToken().then(res => {
      sessionStorage.setItem('token', res)
      checkQrCodeGuid({ guid: this.guid })
        .then(res => {
          if (res.data[0].info === '1')          {
            // if (this.restype) r += '&restype=' + this.restype
            // if (this.autoid) r += '&autoid=' + this.autoid
            // let r = '/scanEntry?module=' + this.module
            // this.$router.push(r)
            let param = {
              module: this.module
            }
            if (this.restype)            {
              param.restype = this.restype
            }
            if (this.autoid)            {
              param.autoid = this.autoid
            }
            this.$router.push({
              path: "/scanEntry",
              query: param
            });
          } else          {
            Notify({ type: 'danger', message: '二维码已过期' })
          }
        })
        .finally(() => {
          this.loading = false
        })
    })
  }
}
</script>

<style></style>
